import { i18n } from '@/i18n';

/** The predefined allergies; anything else is stored as free text. */
export const ALLERGY_KEYS = [
  'penicillin',
  'antibiotics',
  'local_anesthetics',
  'epinephrine',
  'latex',
  'nsaid',
  'aspirin',
  'chlorhexidine',
  'iodine',
  'nickel',
] as const;

export function isAllergyKey(value: string): value is (typeof ALLERGY_KEYS)[number] {
  return (ALLERGY_KEYS as readonly string[]).includes(value);
}

/** A predefined allergy in the UI language, free text as typed. */
export function allergyLabel(value: string): string {
  return isAllergyKey(value) ? i18n.t(`domain:allergy.${value}`) : value;
}
